export interface Amenity {
  name: string
  /** A few words of detail. Omit and the name stands alone. */
  note?: string
}

export interface AmenityGridProps {
  items: Amenity[]
  /**
   * `compact` sets the entries as centred chips in a single wrapping row rather than a
   * column grid — for three or four short facts read at a glance.
   */
  compact?: boolean
  /** Extra classes on the grid. */
  className?: string
}

/**
 * What a place has, set like the card on the back of a hotel door.
 *
 * **Deliberately without icons.** `flaticon_charitics` is around seventy glyphs and has
 * none for a restaurant, a sauna or a cinema; a grid where two thirds of the entries fall
 * back to a generic tick reads worse than a grid with none, and the diamond marker is the
 * more elegant answer anyway. If a pictorial set is ever chosen, it belongs here and
 * nowhere else.
 */
export function AmenityGrid({ items, compact = false, className }: AmenityGridProps) {
  const classes = [
    'ul-amenity-grid',
    compact ? 'ul-amenity-grid--compact' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <ul className={classes}>
      {items.map((item) => (
        <li className="ul-amenity" key={item.name}>
          <span>
            <span className="ul-amenity-name">{item.name}</span>
            {item.note && <span className="ul-amenity-note">{item.note}</span>}
          </span>
        </li>
      ))}
    </ul>
  )
}
